import applePay from "@core/assets/icons/apple-pay.svg?raw";
import googlePay from "@core/assets/icons/google-pay.svg?raw";
import mastercard from "@core/assets/icons/mastercard.svg?raw";
import visa from "@core/assets/icons/visa.svg?raw";
import { PaymentType } from "@core/schema/PaymentType.js";

export const paymentTypeIconMap: Partial<Record<PaymentType, string[]>> = {
	[PaymentType.GoPayPaymentCard]: [visa, mastercard],
	[PaymentType.GoPayApplePay]: [applePay],
	[PaymentType.GoPayGPay]: [googlePay],
};
